import { BehaviorSubject } from 'rxjs'
import { createMapSubjectValueHook } from 'src/utils/rx'

const $userFollowed = new BehaviorSubject<Record<string, boolean>>({})

export const useUserFollowed = createMapSubjectValueHook($userFollowed, false)

const $userFollowingMe = new BehaviorSubject<Record<string, boolean>>({})

export const useUserFollowingMe = createMapSubjectValueHook(
  $userFollowingMe,
  false,
)

const $userFollowerCount = new BehaviorSubject<Record<string, number>>({})

export const useUserFollowerCount = createMapSubjectValueHook(
  $userFollowerCount,
  0,
)
